import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import DashboardPage from '../../pages/DashboardPage';
import ProfilePage from '../../pages/ProfilePage';
import { usePageOverlayStore } from '../../stores/pageOverlayStore';
import './UsodekiPageOverlay.css';

/**
 * usodeki 用ページオーバーレイ。利用状況 / マイページをホーム上にかぶせて開き、
 * ✕ (または背景クリック・Escape) で閉じて元の画面へ戻れるようにする。
 * 別ルートへのフルリロードを置き換え、戻る導線を確保する。
 */
export function UsodekiPageOverlay() {
  const active = usePageOverlayStore((s) => s.active);
  const close = usePageOverlayStore((s) => s.close);

  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    // オーバーレイ表示中は背面スクロールを抑止
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [active, close]);

  if (!active) return null;

  const title = active === 'dashboard' ? '利用状況' : 'マイページ';

  return createPortal(
    <div className="usodeki-overlay" onClick={close}>
      <div className="usodeki-overlay-panel" onClick={(e) => e.stopPropagation()}>
        <div className="usodeki-overlay-header">
          <button
            type="button"
            className="usodeki-overlay-back"
            onClick={close}
            aria-label="戻る"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" />
            </svg>
            <span>戻る</span>
          </button>
          <span className="usodeki-overlay-title">{title}</span>
          <button
            type="button"
            className="usodeki-overlay-close"
            onClick={close}
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>
        <div className="usodeki-overlay-body">
          {active === 'dashboard' ? <DashboardPage /> : <ProfilePage />}
        </div>
      </div>
    </div>,
    document.body,
  );
}
